import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import './style.css';

export default function TermsCondition() {
  return (
    <div className="terms_bg">
      <SEO {...pageSEO.termsConditions} />
      <div className="terms_condition_banner"></div>

      <div className="terms_content">
        <h1>Terms & Conditions</h1>
        <h3>(Boundless Trends Pvt. Ltd.)</h3>

        <section>
          <p>
            <b>Governing Law:</b> Indian Laws (including the Information Technology Act, 2000, Consumer Protection Act, 2019, and other applicable Law, rules and regulations).
          </p>
        </section>

        <section>
          <h2><b>1. Introduction</b></h2>
          <p>Welcome to Importerr.com (“Platform”, “Website”, “We”, “Us”, “Our”). By accessing, browsing, registering , purchasing or using any services of Platform, you (“User”, “You”, “Buyer”) acknowkledge and agree that you have read, understood and accepted these Terms and Conditions. If you do not agree, you must immediately discontinue use of the Platform immediately.</p>
          <br />
          <p>Importerr.com is an <b>intermediary facilitation platform</b> and not the “seller” or “Importer”. The Buyer shall at all times be deemed to be the Importer of the goods for the purposes of customs, taxation, regulatory compliances etc.</p>
        </section>

        <section>
          <h2><b>2. Nature of Services</b></h2>
          <ul>
            <li>
              Importerr.com is an <b>intermediary facilitation platform</b> that provides its users with access to a catalog of global suppliers (primarily Chinese suppliers) and enables them to discover, request, and procure products for import into India.
            </li>
            <li>Importerr.com (and its associated companies) may maintain partnerships with Alibaba and its affiliates; however, Importerr.com has <b>no control over the products, descriptions, pricing, or search results</b> displayed by such third-party platforms.</li>
            <li>
              Importerr.com does not manufacture, own, or control =any products listed on its platform. All product listings, specificatioins and other details are solely provided by independent third-party suppliers.Importerr.com doesnot support any claim extended by anyof the product listed on its website.
            </li>
            <li>Orders placed on Importerr.com are treated as requests for procurement, subject to supplier acceptance, regulatory compliance, and logistics feasibility.</li>
            <li>The Buyer expressly understands and agrees that Importerr.com shall not act as the “Importer” for customs purposes. The Buyer shall remain the Importer and be solely responsible for compliance with applicable Indian laws, licenses, and approvals.</li>
          </ul>
        </section>

        <section>
          <h2><b>3. Restricted, Prohibited &amp; Regulated Products</b></h2>
          <ul>
            <li>The product catalog accessible through Importerr.com may display items that are:</li>
              <ul>
                <li>Restricted or prohibited under Indian laws • Prohibited for air/sea transport due to safety regulations.</li>
                <li>Subject to intellectual property <b>protection</b> in India under the <b>Trade Marks Act, 1999,</b> the <b>Copyright Act, 1957,</b> or related laws</li>
                <li>Products requiring special licenses, approvals, or regulatory certificates (e.g., BIS, WPC, CDSCO, FSSAI, DGFT permissions, etc.), which cannot be imported without compliance.</li>
              </ul>
            <li>
              Importerr.com shall not procure, process or import any such restricted or regulated products unless the Buyer provides all valid original documents/approvals/statutory clearances as required under Indian law.
            </li>
            <li>Importerr.com shall not be liable for <b>seizure, confiscation, penalty, or prosecution</b> initiated by Customs or any statutory authority arising out of non-compliance, misdeclaration, or import of prohibited/restricted products by the Buyer.</li>
            <li>Importerr.com reserves the absolute right to cancel or reject any order at any stage at its sole discretion and without assigning any reason whatsoever. In such cases, Importerr.com shall not be responsible for any consequences, losses, or damages arising out of such cancellation, except refunding any advance amount received after applicable deductions.</li>
          </ul>
        </section>

        <section>
          <h2><b>4. Order Placement, Processing &amp; Cancellation</b></h2>
          <ul>
            <li>Order Placement <b>amounts to Request, Not Confirmation:</b> Placement of an order on Importerr.com shall be treated only as a <b>request for procurement</b> and shall not constitute final acceptance or confirmation by Importerr.com or the supplier. An order shall be confirmed only upon (i) supplier acceptance, (ii) compliance with applicable Indian laws, and (iii) fulfillment of all documentation and payment requirements.</li>
            <li>Non-Cancellation by Buyer: Once an order has been placed on the platform or Importerr.com has started processing it, the Buyer shall have no right to cancel the order under any circumstances.</li>
            <li>
              Cancellation by Importerr: Importerr.com retains absolute right and discretion to cancel any order at any stage, without providing a reason. The Buyer hereby expressly waives any claim, demand, or legal action against Importerr.com for such cancellation.
            </li>
            <li>Importerr.com or the supplier may also reject/cancel any order for reasons including but not limited to:</li>
              <ul>
                <li>Supplier refusal to fulfill the order.</li>
                <li>Product restrictions under law.</li>
                <li>Missing or invalid regulatory certifications.</li>
                <li>Incorrect or missing weight/dimension details.</li>
                <li>Logistical or customs clearance issues.</li>
              </ul>
            <li><b>Liability on Cancellation:</b> In case of cancellation by Importerr.com, the Buyer shall only be entitled to a refund of any advance payment received, after deduction of actual costs, charges, or expenses incurred up to the date of cancellation. Importerr.com shall not be liable for any <b>consequential damages, loss of business, profits, or reputation</b> arising out of such cancellation.</li>
          </ul>
        </section>

        <section>
          <h2><b>5. Product Information &amp; Weight Disclaimer</b></h2>
          <ul>
            <li>
              All product listings, including but not limited to <b>weight, dimensions, specifications, descriptions, and images,</b> are based solely on information provided by independent third-party suppliers. Importerr.com does not independently verify, test, or certify the accuracy of such information. -  The Buyer acknowledges and agrees that: <b>Actual weight, dimensions, volume, or specifications</b> of products may differ from the details provided in the supplier listing;
              <ul>
                <li>Customs duty, freight charges, and shipping costs are often assessed based on <b>actual weight/volume</b> at the time of export/import, and such assessment may differ from supplier-provided details.</li>
              </ul>
            </li>
            <li>Some listings may not display product weight at all.</li>
            <li>Importerr.com is not liable for discrepancies in supplier-provided information.</li>
          </ul>
        </section>

        <section>
          <h2><b>6. Intellectual Property &amp; Brand Rights</b></h2>
          <ul>
            <li>The Buyer acknowledges that some third-party suppliers may list products that <b>resemble, imitate, or are deceptively similar</b> to well-known international or Indian brands. Importerr.com does not verify, endorse, certify, or guarantee the authenticity, originality, or legality of any such products for which importer.com takes no responsibility.</li>
            <li>
              Importerr.com expressly disclaims any responsibility for:
                <ul>
                  <li>The genuineness, originality, or brand authenticity of products listed by suppliers;</li>
                  <li>Any misrepresentation or false claims made by suppliers with respect to trademarks, copyrights, patents, or design rights;</li>
                  <li>Any liability arising under the <b>Trade Marks Act, 1999, the Copyright Act, 1957, the Patents Act, 1970,</b> or any other applicable intellectual property law in India or abroad.</li>
                </ul>
            </li>
            <li>The Buyer shall be <b>solely and entirely responsible</b> for ensuring that the goods they import do not infringe any intellectual property rights in India or in the country of origin. The Buyer further undertakes to conduct necessary due diligence and obtain any brand authorizations, permissions, or licenses as may be required.</li>
            <li>Importerr.com shall not be liable for, and the Buyer shall indemnify and hold Importerr.com harmless against, any <b>claims, seizures, damages, penalties, fines, or legal proceedings</b> initiated by customs authorities, brand owners, enforcement agencies, or third parties arising from alleged or actual intellectual property infringement.</li>
          </ul>
        </section>

        <section>
          <h2><b>7. Pricing &amp; Estimates</b></h2>
          <ul>
            <li>
              Prices displayed on Importerr.com are estimates only.
            </li>
            <li>Final payable amount may differ due to:
              <ul>
                <li>Currency fluctuations.</li>
                <li>Shipping/freight charges.</li>
                <li>Customs duty, GST, and other applicable taxes.</li>
                <li>Supplier revisions.</li>
              </ul>
            </li>
            <li>Importerr.com does not guarantee fixed pricing until the order is confirmed and paid in full.</li>
          </ul>
        </section>

        <section>
          <h2><b>8. Limitation of Liability</b></h2>
          <p>To the maximum extent permitted by law:</p>
          <ul>
            <li>
              Importerr.com is an intermediary platform and not the manufacturer, seller, or importer of record.
            </li>
            <li>Importerr.com is not liable for:
              <ul>
                <li>Delays, cancellations, or non-fulfillment by suppliers.</li>
                <li>Losses due to customs seizure, regulatory action, or logistics failure.</li>
                <li>Product defects, damages, or misrepresentations by suppliers.</li>
                <li>IP infringement claims, fines, or penalties on imported products.</li>
              </ul>
            </li>
            <li>Buyer agrees that Importerr.com’s liability is limited strictly to refund of amounts collected for unprocessed orders, if applicable.</li>
          </ul>
        </section>

        <section>
          <h2><b>9. Compliance with Indian Laws</b></h2>
          <ul>
            <li>
              Buyers must comply with all applicable laws including Customs Act, 1962, Foreign Trade (Development &amp; Regulation) Act, 1992, and related notifications.
            </li>
            <li>
              Buyers must provide correct KYC, import documents, and tax details as required.
            </li>
            <li>
              Importerr.com reserves the right to cancel orders if Buyers fail to provide required compliance documents.
            </li>
          </ul>
        </section>

        <section>
          <h2><b>10. Indemnity</b></h2>
          <p>You agree to indemnify and hold harmless Importerr.com, its owners, directors, employees, and affiliates against any claims, damages, penalties, or legal proceedings arising out of:</p>
          <ul>
            <li>Violation of Indian laws by importing restricted/prohibited products.</li>
            <li>Importing products without required licenses or certificates.</li>
            <li>Intellectual property infringement.</li>
            <li>Misuse of the Platform or false information provided.</li>
          </ul>
        </section>

        <section>
          <h2><b>11. Dispute Resolution</b></h2>
          <ul>
            <li>Any disputes shall first be attempted to be resolved amicably.</li>
            <li>If unresolved, disputes shall be subject to the exclusive jurisdiction of the courts of Jaipur, Rajasthan, India.</li>
          </ul>
        </section>

        <section>
          <h2><b>12. Amendments</b> </h2>
            <p>Importerr.com reserves the right to amend, modify, or update these Terms at any time without prior notice. Continued use of the Platform constitutes acceptance of updated Terms.</p>
        </section>

        <section>
          <h2><b>⚠️ Short Disclaimer:</b></h2>
            <p>Importerr.com is an intermediary platform providing access to global supplier catalogs. Orders placed are subject to supplier acceptance, regulatory compliance, and Importerr’s discretion. Importerr reserves the right to cancel any order at any time without assigning a reason. Buyers cannot cancel orders once placed or processed. Importerr is not liable for restricted products, supplier refusal, weight discrepancies, IP issues, or customs restrictions.</p>
        </section>
      </div>
    </div>
  );
}
